/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Flex } from "@chakra-ui/react";
import AppSpinner from "components/spinner/AppSpinner";
import OrderLayout from "../layout/OrderLayout";
import { useOrder } from "../hooks/useOrder";
import Step1Service from "../steps/Step1Service";
import Step2Documents from "../steps/Step2Documents";
import Step3Options from "../steps/Step3Options";
import Step4Payment from "../steps/Step4Payment";

export default function OrderPage() {
  const { step, maxStep, isHydrating, goTo, next, back } = useOrder();

  if (isHydrating) {
    return (
      <Flex width="100%" minH="100vh" alignItems="center" justifyContent="center">
        <AppSpinner />
      </Flex>
    );
  }

  return (
    <Box display={{ md: "block", base: "flex" }} px="0" flexDirection="column" flex={1}>
      <OrderLayout step={step} maxStep={maxStep} onStepClick={goTo}>
        {step === 1 && <Step1Service onNext={next} />}
        {step === 2 && <Step2Documents onNext={next} onBack={back} />}
        {step === 3 && <Step3Options onNext={next} onBack={back} />}
        {step === 4 && <Step4Payment onBack={back} />}
      </OrderLayout>
    </Box>
  );
}
